import axios from 'axios';

import { type PaymentMethod, type PaymentSession } from '../../shared/paymentTypes';

async function createPaymentSession(paymentType: PaymentMethod): Promise<PaymentSession> {
    const response = await axios.post<PaymentSession>('/api/cart/create-payment-session', {
        paymentType,
    });

    return response.data;
}

export { createPaymentSession };
